import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { PageLayout } from '@hero/layouts';
import { OrderConfirmed } from '@hero/organisms';
import { useGetAutomation } from '@hero/services';

function AutomationOrderConfirmed() {
  const { automationId } = useParams();
  const { t } = useTranslation();
  const { data } = useGetAutomation({ code: automationId });

  const isRecognition = window?.location.pathname.includes('recognition');
  const orderType = isRecognition ? t('oneTimeGift') : t('automation');

  return (
    <PageLayout
      header={{
        title: t('orderReceived', { featureType: orderType })
      }}
    >
      <OrderConfirmed id={automationId} data={data} />
    </PageLayout>
  );
}

export { AutomationOrderConfirmed };
